<div class='content measure-module'>
  <p>Měření vzdáleností a ploch v mapě.</p>
  <gmt-switch [options]="measureOptions" [(selectedId)]="measureOptionsSelections" (select)="onChangedMeasureType($event.id)">
  </gmt-switch>
</div>
